import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-700 animate-floaty">
          <i className="ri-emotion-sad-line"></i>
        </span>
        <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm text-foreground-600">
          没有找到你要访问的页面：<span className="text-foreground-900">{location.pathname}</span>
        </p>
        <p className="mt-1 text-sm text-foreground-500">它可能已经被移动，或者链接有点小问题。</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition hover:bg-primary-400"
          >
            <i className="ri-home-5-line text-lg"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="flex items-center gap-2 rounded-full border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-700 transition hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-movie-2-line text-lg"></i>
            浏览片库
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}